"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var IConfig_1 = require("./Interfaces/IConfig");
var NotInitedError_1 = __importDefault(require("./Errors/NotInitedError"));
var AlreadyInitedError_1 = __importDefault(require("./Errors/AlreadyInitedError"));
var Connector_1 = require("./Helper/Connector");
var IUser_1 = require("./Interfaces/IUser");
var TypeGuardError_1 = __importDefault(require("./Errors/TypeGuardError"));
var IChallenge_1 = require("./Interfaces/IChallenge");
var IWriteResponse_1 = require("./Interfaces/IWriteResponse");
var Artcare = /** @class */ (function () {
    function Artcare() {
        this.apiKeys = null;
        this.url = null;
        this.cookies = "auto";
        this.activeCookies = [];
    }
    Artcare.prototype.init = function (_a) {
        var apiKeys = _a.apiKeys, url = _a.url, _b = _a.cookies, cookies = _b === void 0 ? "auto" : _b, _c = _a.origin, origin = _c === void 0 ? null : _c;
        var testConfig = { apiKeys: this.apiKeys, url: this.url };
        if (IConfig_1.isInited(testConfig))
            throw new AlreadyInitedError_1.default("The SDK has already been inited.");
        this.apiKeys = apiKeys;
        this.url = url;
        this.cookies = cookies;
        this.origin = origin;
    };
    Artcare.prototype.login = function (username, password) {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Connector_1.send("auth", "POST /idp/login", {
                            email: username,
                            password: password,
                        })];
                    case 1:
                        user = _a.sent();
                        return [2 /*return*/, user];
                }
            });
        });
    };
    Artcare.prototype.register = function (user) {
        return __awaiter(this, void 0, void 0, function () {
            var challenge;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Connector_1.send("auth", "POST /idp/register", user)];
                    case 1:
                        challenge = _a.sent();
                        if (IChallenge_1.isChallenge(challenge))
                            return [2 /*return*/, challenge];
                        throw new TypeGuardError_1.default("POST /idp/register", "IChallenge");
                }
            });
        });
    };
    Artcare.prototype.challenge = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Connector_1.send("auth", "POST /idp/challenge", data)];
                    case 1:
                        response = _a.sent();
                        if (IUser_1.isUser(response))
                            return [2 /*return*/, response];
                        if (IChallenge_1.isChallenge(response))
                            return [2 /*return*/, response];
                        throw new TypeGuardError_1.default("POST /idp/challenge", "IUser | IChallenge");
                }
            });
        });
    };
    Artcare.prototype.whoAmI = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Connector_1.request("auth", "GET /idp/whoami")];
                    case 1:
                        response = _a.sent();
                        if (IUser_1.isUser(response))
                            return [2 /*return*/, response];
                        return [2 /*return*/, null];
                }
            });
        });
    };
    Artcare.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, Connector_1.request("auth", "DELETE /idp/logout")];
            });
        });
    };
    Artcare.prototype.updateSettings = function (data, id) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Connector_1.send("auth", "PUT /idp/settings", data, { id: id })];
                    case 1:
                        response = _a.sent();
                        if (IWriteResponse_1.isWriteResponse(response))
                            return [2 /*return*/, response];
                        throw new TypeGuardError_1.default("PUT /idp/settings", "IWriteResponse");
                }
            });
        });
    };
    Artcare.prototype.helper = function () {
        return Connector_1.request("auth", "GET /idp/helper");
    };
    Artcare.prototype.getConfig = function () {
        var config = {
            apiKeys: this.apiKeys,
            url: this.url,
            cookies: this.cookies,
            orgin: this.origin,
        };
        if (IConfig_1.isInited(config))
            return config;
        throw new NotInitedError_1.default("The SDK has not been inited yet");
    };
    Artcare.prototype.addCookie = function (cookie) {
        var key = cookie.split("=")[0];
        this.activeCookies = this.activeCookies.filter(function (setCookie) {
            var setKey = setCookie.split("=")[0];
            return key !== setKey;
        });
        this.activeCookies.push(cookie);
    };
    Artcare.prototype.getCookieHeader = function () {
        return this.activeCookies.join("; ");
    };
    return Artcare;
}());
var artcare = new Artcare();
exports.default = artcare;
